import { Button, FormWrapper, IconRow } from 'components'

import { BsClockHistory } from 'react-icons/bs'

import { useTranslation } from 'react-i18next'
import { MdOutlineHowToVote } from 'react-icons/md'
import { useRef } from 'react'
import './OneStopPlanScreen.scss'

const FIND_POLLING_PLACE_URL =
  'https://www.pavoterservices.pa.gov/Pages/PollingPlaceInfo.aspx'
const EARLY_VOTING_URL = 'https://www.vote.pa/early'

const BUTTON_WRAPPER_STYLE = { marginTop: 30, marginBottom: 40 }

export const OneStopPlanScreen = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: `oneStop.planScreen`,
  })
  const wrapperRef = useRef(null as HTMLElement | null)

  return (
    <FormWrapper id={`one-stop__plan`} title={t(`title`)} formRef={wrapperRef}>
      <div className="one-stop">
        <IconRow
          icon={BsClockHistory}
          iconColor="blue"
          text={t('earlyVoting.title')}
        ></IconRow>
        <p>{t('earlyVoting.lineOne')}</p>
        <p dangerouslySetInnerHTML={{ __html: t(`earlyVoting.lineTwo`) }}></p>
        <div style={BUTTON_WRAPPER_STYLE}>
          <Button
            label={t('earlyVoting.button')}
            onClick={() => window.open(EARLY_VOTING_URL)}
            fullWidth={false}
          />
        </div>
        <IconRow
          icon={MdOutlineHowToVote}
          iconColor="blue"
          text={t('findMyPollingPlace.title')}
        ></IconRow>
        <p>{t('findMyPollingPlace.lineOne')}</p>
        <div style={BUTTON_WRAPPER_STYLE}>
          <Button
            label={t('findMyPollingPlace.button')}
            onClick={() => window.open(FIND_POLLING_PLACE_URL)}
            fullWidth={false}
          />
        </div>
      </div>
    </FormWrapper>
  )
}
